import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { FleetSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const fleetMenuItemTitle = 'Settings.Fleet';

export const fleetMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.Fleet.GeofenceLocation',
    routerLink: FleetSettingsRouteName.GeofenceLocation,
    permissions: [RolesAndPermissions.FleetSettingsGeofenceRead],
  },
  {
    label: 'Settings.Fleet.PredefinedGeofence',
    routerLink: FleetSettingsRouteName.PredefinedGeofence,
    permissions: [RolesAndPermissions.FleetSettingsGeofenceRead],
  },
];

export enum GeofenceType {
  Temporary = 'Temporary',
  Permanent = 'Permanent',
}
